import { ApiBlueprint } from '@backstage/frontend-plugin-api';
import {
  createApiRef,
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
  createApiFactory,
  discoveryApiRef,
  oauthRequestApiRef,
  configApiRef,
  gitlabAuthApiRef,
} from '@backstage/core-plugin-api';
import { OAuth2 } from '@backstage/core-app-api';

export const oidcAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: 'auth.oidc',
});

export const oidcAuthApi = ApiBlueprint.make({
  name: 'oidc',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: oidcAuthApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          oauthRequestApi: oauthRequestApiRef,
          configApi: configApiRef,
        },
        factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
          OAuth2.create({
            discoveryApi,
            oauthRequestApi,
            provider: {
              id: 'oidc',
              title: 'Sulmara OIDC',
              icon: () => null,
            },
            environment: configApi.getOptionalString('auth.environment'),
            defaultScopes: ['openid', 'username', 'groups', 'offline_access'],
          }),
      })
    ),
});

export const gitlabAuthApi = ApiBlueprint.make({
  name: 'gitlab-auth',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: gitlabAuthApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          oauthRequestApi: oauthRequestApiRef,
          configApi: configApiRef,
        },
        factory: ({ discoveryApi, oauthRequestApi, configApi }) =>
          OAuth2.create({
            discoveryApi,
            oauthRequestApi,
            provider: {
              id: 'gitlab',
              title: 'GitLab',
              icon: () => null,
            },
            environment: configApi.getOptionalString('auth.environment'),
            defaultScopes: ['read_user', 'read_api', 'read_repository', 'write_repository', 'openid', 'profile', 'email'],
          }),
      })
    ),
});

import {
  kubernetesAuthProvidersApiRef,
  KubernetesAuthProviders,
} from '@backstage/plugin-kubernetes-react';
import { googleAuthApiRef, microsoftAuthApiRef } from '@backstage/core-plugin-api';

export const kubernetesAuthProvidersApi = ApiBlueprint.make({
  name: 'kubernetes-auth',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: kubernetesAuthProvidersApiRef,
        deps: {
          oidcAuthApi: oidcAuthApiRef,
          googleAuthApi: googleAuthApiRef,
          microsoftAuthApi: microsoftAuthApiRef,
        },
        factory: ({ oidcAuthApi, googleAuthApi, microsoftAuthApi }) => {
          return new KubernetesAuthProviders({
            microsoftAuthApi,
            googleAuthApi,
            oidcProviders: {
              oidc: oidcAuthApi,
            },
          });
        },
      })
    ),
});
